import { render, staticRenderFns } from "./SpecialTriangleViz.vue?vue&type=template&id=bf7ccbea&scoped=true"
import script from "./SpecialTriangleViz.vue?vue&type=script&lang=js"
export * from "./SpecialTriangleViz.vue?vue&type=script&lang=js"
import style0 from "./SpecialTriangleViz.vue?vue&type=style&index=0&id=bf7ccbea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ccbea",
  null
  
)

export default component.exports